import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { PhoneRegisterListItem } from '../../models/phone-register-results.model';
import { PhoneTypeOption } from '../models/phone-type-option.interface';

const area = 'Extension Phone Register';
export const extensionPhoneRegisterAdapterActions = createRegisterActions<PhoneRegisterListItem>(area);

export const createExtensionPhone = createAction(
   `[${area}] Create Extension Phone`,
   props<{ createPhoneTypeOption: PhoneTypeOption; accountId: number | null; accountShortName: string | null }>()
);

export const editExtensionPhone = createAction(
   `[${area}] Edit Extension Phone`,
   props<{ phone: PhoneRegisterListItem; accountId: number | null }>()
);

export const deleteExtensionPhone = createAction(`[${area}] Delete Extension Phone`, props<{ phoneId: number }>());

export const deleteExtensionPhoneConfirm = createAction(
   `[${area}] Delete Extension Phone Confirm`,
   props<{ phoneId: number }>()
);

export const deleteExtensionPhoneCancel = createAction(`[${area}] Delete Extension Phone Cancel`);

export const deleteExtensionPhoneSuccess = createAction(
   `[${area}] Delete Extension Phone Success`,
   props<{ phoneId: number }>()
);

export const deleteExtensionPhoneFailure = createAction(
   `[${area}] Delete Extension Phone Failure`,
   props<SingleGraphError>()
);

export const updateInvalidPhones = createAction(
   `[${area}] Update Invalid Phones`,
   props<{ invalidPhoneIds: number[] }>()
);

export const changeSipUserPassword = createAction(`[${area}] Change Sip User Password`, props<{ sipUserId: number }>());

export const changeSipUserPasswordSuccess = createAction(`[${area}] Change Sip User Password Success`);

export const changeSipUserPasswordFailure = createAction(
   `[${area}] Change Sip User Password Failure`,
   props<SingleGraphError>()
);
